import topic from '../topic'
export const mpinAPI = {
    getMpins: topic.mpinTopic + '/get_mpins',
    // getMpinById: topic.mpinTopic + '/get_mpin_by_id',
    // addMpin: topic.mpinTopic + '/add_mpin',
    // editMpin: topic.mpinTopic + '/edit_mpin',
    destroyMpinByIds: topic.mpinTopic + '/destroy_mpin_by_ids'
}